var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconService4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2108 12.1503H2.88224C1.68224 12.1503 1.16796 10.8431 2.11081 10.2217L14.7751 1.92883C15.0089 1.79128 15.2753 1.71875 15.5465 1.71875C15.8178 1.71875 16.0841 1.79128 16.318 1.92883L28.9822 10.2217C29.9251 10.8431 29.4108 12.1503 28.2108 12.1503Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4039 23.9355H2.68959C2.09786 23.9355 1.61816 24.4152 1.61816 25.007V28.2213C1.61816 28.813 2.09786 29.2927 2.68959 29.2927H28.4039C28.9956 29.2927 29.4753 28.813 29.4753 28.2213V25.007C29.4753 24.4152 28.9956 23.9355 28.4039 23.9355Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83203 12.1504V23.9361",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1895 12.1504V23.9361",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5469 12.1504V23.9361",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9043 12.1504V23.9361",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2607 12.1504V23.9361",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconService4);
export default __webpack_public_path__ + "static/media/icon-service-4.2c05c47852c2bc4b00bc0dc80cd662ac.svg";
export { ForwardRef as ReactComponent };